import $ from 'jquery';
import 'jquery-ui/ui/widgets/tabs';
import 'jquery-ui/ui/widgets/sortable';
import 'jquery-ui/ui/disable-selection';
import 'jquery-ui/themes/base/base.css';
import Scrollbar from 'smooth-scrollbar';
import 'smooth-scrollbar'
import 'jquery-validation/dist/jquery.validate.min.js';
import 'datatables.net-dt';
import 'datatables.net-dt/css/jquery.dataTables.css';
//import 'datatables.net-scroller-dt';
//import 'datatables.net-scroller-dt/css/scroller.dataTables.css';
import 'select2';
import 'select2/dist/css/select2.min.css';
import {daterangepicker, getDateRangePicker} from '@wernfried/daterangepicker';
import '@wernfried/daterangepicker/css/daterangepicker.css';
import ClipboardJS from 'clipboard';
import { DateTime } from "luxon";

import tinymce from 'tinymce/tinymce';
import 'tinymce/themes/modern/theme';
import 'tinymce/plugins/link/plugin';
import 'tinymce/plugins/lists/plugin';
import 'tinymce/plugins/paste/plugin';
//import 'tinymce/plugins/charmap/plugin';
//import 'tinymce/plugins/directionality/plugin';
//import 'tinymce/plugins/fullscreen/plugin';
//import 'tinymce/plugins/spellchecker/plugin';
//import 'tinymce/plugins/tabfocus/plugin';
//import 'tinymce/plugins/textcolor/plugin';
import 'tinymce/skins/lightgray/skin.min.css';
//import 'tinymce/skins/lightgray/content.min.css';



$(document).ready( function() {
    var $window = $(window);
    var $document = $(document);
    var windowWidth = $window.width();
    var windowHeight = $window.height();
    var $body = $('body');
    var $header = $('#header');
    var $mainNav = $('#mainNav');
    var headerHeight = $header.outerHeight();

    $window.resize(function () {
        windowWidth = $window.width();
        windowHeight = $window.height();
        headerHeight = $header.outerHeight();
    });

    $.ajaxSetup({
        url: selectrum.ajax_url,
        type: 'POST',
        error: function(jqXHR, textStatus, errorThrown) {
            //fancyboxManager.setContent( 'Something went wrong. Please try again later or contact the website administrator.' );
        }
    });

    /**
     * jQuery Validation Custom methods
     */
    $.validator && $.validator.setDefaults({
        ignore: [],
        errorElement: 'span',
        //errorClass: 'formField__error',
        // any other default options and/or rules
        errorPlacement: function(error, element) {
            error.appendTo( element.parents('.formField') );
        }
    });


    $(".panelTabs").tabs();


    function ajaxRequest(customArgs) {
        var defaultArgs = {
            url: selectrum.ajax_url,
            method: 'POST',
            beforeSend: function () {
                popupManager.loading();
            },
            success: function ( response ) {
                if ( response.data.type ) {
                    switch ( response.data.type ) {
                        case 'reload':
                            location.reload();
                            break;
                        case 'redirect':
                            location.href = response.data.redirect;
                            break;
                    }
                } else if ( response.data ) {
                    popupManager.setContent( response.data );
                } else {
                    popupManager.close();
                }
            }
        }
        var args = $.extend({}, defaultArgs, customArgs);
        $.ajax(args);
    }


    function updateElement( selector, callback = (()=>{}) ) {
        $.ajax({
            url: location.href,
            success: function (response) {
                $(selector).replaceWith( $(response).find(selector) );
                callback();
            }
        });
    }

    tinymce.init({
        //selector: 'textarea',
        wpautop: true,
        menubar: false,
        height: 150,
        plugins: 'lists paste link',
        toolbar: 'formatselect bold italic | bullist numlist | blockquote | alignleft aligncenter alignright | link unlink',
        setup: function (editor) {
            editor.on('change', function () {
                tinymce.triggerSave();
            });
        }
    });


    $document.on('afterClose.fb', function () {
        tinymce.EditorManager.execCommand('mceRemoveEditor', true, 'popup-notes');
        tinymce.EditorManager.execCommand('mceRemoveEditor', true, 'popup-description');
    });


    $document.on('beforeShow.fb', function( e, instance, slide ) {

    });


    $document.on('afterShow.fb', function( e, instance, slide ) {
        var $popup = $(slide.$slide);

        $popup.find('.timeEntriesTable').each(function (index, element) {
            var datatable = $(element).DataTable({
                paging: false,
                scrollCollapse: true,
                scrollY: '340px',
                info: false,
                searching: false,
                order: [[ 1, 'asc' ]],
                columnDefs: [
                    {
                        orderable: false,
                        targets: [2,3]
                    }
                ],
                scroller: true,
                bStateSave: true,
            });
        })

        //Notes form
        $popup.find('.formNotes').each(function (index, element) {
            var validator = $(element).validate({
                submitHandler: function (form) {
                    var $form = $(form);
                    $form.addClass('loading');
                    $.ajax({
                        data: $(form).serialize(),
                        success: function () {
                            $form.removeClass('loading');
                            popupManager.close();
                        }
                    });
                }
            });
        });


        //Next task form
        $popup.find('.formNextTask').each(function (index, element) {
            var validator = $(element).validate({
                submitHandler: function (form) {
                    var $form = $(form);
                    $form.addClass('loading');
                    $.ajax({
                        data: $(form).serialize(),
                        success: function () {
                            $form.removeClass('loading');
                            popupManager.close();
                        }
                    });
                }
            });
        });

        tinymce.EditorManager.execCommand('mceAddEditor', true, 'popup-notes');
        tinymce.EditorManager.execCommand('mceAddEditor', true, 'popup-description');

        //Time form
        $popup.find('.formTime').each(function (index, element) {
            var validator = $(element).validate({
                submitHandler: function (form) {
                    var $form = $(form);
                    $form.addClass('loading');
                    $.ajax({
                        data: $(form).serialize(),
                        success: function ( response ) {
                            if ( response.success ) {
                                var datatable = $popup.find('.timeEntriesTable').DataTable();
                                var $row = $(response.data.content);
                                $row.addClass('highlighted');
                                var node = datatable.row.add( $row ).draw().node();
                                //datatable.row( node ).scrollTo();
                                node.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                $(node).removeClass("highlighted");
                                $form.find('input[name="time"]').val('');
                                validator.resetForm();
                                //$('#main').load( location.href + ' #main > *' );
                                $document.trigger('elements_updated', response.data.ancestors_ids);
                            }
                            $form.removeClass('loading');
                        }
                    });
                }
            });
        });

        $('input[name="date"]').daterangepicker({
            singleDatePicker: true,
            //showDropdowns: true,
            minYear: 2010,
            locale: {
                format: 'yyyy-MM-dd'
            },
            drops: 'up',
            autoApply: true,
            maxDate: DateTime.now().toISODate()
        });
    });


    /**
     * Process Scroll event
     */
    var previousScrollTop = 0;
    $window.on("load scroll", function () {
        var scrollTop = $document.scrollTop();
        if (scrollTop > 0) {
            $body.addClass('scrolled');
            $header.addClass('siteHeader--sticky');
            $('#btnMenu').addClass('btnMenu--sticky');
            $mainNav.addClass('mainNav--sticky');
        } else {
            $body.removeClass('scrolled');
            $header.removeClass('siteHeader--sticky');
            $('#btnMenu').removeClass('btnMenu--sticky');
            $mainNav.removeClass('mainNav--sticky');
        }

        previousScrollTop = scrollTop;
    });


    /**
     * Process hash links
     */
    $body.on('click', 'a[href*=\\#]', function (e) {

        if ( $(this).hasClass('ui-tabs-anchor') )
            return false;

        var url = $(this).attr('href');
        var hash = url.substring(url.indexOf('#'));
        if ($(hash).length) {
            e.preventDefault();
            processHash(hash);
        }
    });

    function processHash(hash) {
        var $element = $(hash);
        var hashValue = hash.substr(1);

        if ($element.length) {
            var elementOffset = $element.offset().top;
            var elementHeight = $element.outerHeight();
            var elementCenter = elementOffset + elementHeight/2;

            $('html, body').animate({
                scrollTop: elementHeight > windowHeight ? elementOffset : elementCenter - windowHeight/2
            }, 'normal');
        }
    }

    $window.on("load", function () {
        if (window.location.hash) {
            processHash(window.location.hash);
        }
    });






    $('.loginBlock__form').each(function (index, form) {
        var $form = $(form);
        $form.validate({
            submitHandler: function () {
                ajaxRequest({
                    data: $form.serialize(),
                });
            }
        });
    });


    if ( $('.statusBar').length ) {
        $.fn.dataTable.ext.search.push(
            function( settings, searchData, index, rowData, counter ) {
                var statuses = $('input:checkbox[name="statuses[]"]:checked').map(function() {
                    return this.value;
                }).get();

                if (statuses.length === 0) {
                    return false;
                }

                if (statuses.indexOf(searchData[1]) !== -1) {
                    return true;
                }

                return false;
            }
        );
    }


    if ( $('.assigneesBar').length ) {
        $.fn.dataTable.ext.search.push(
            function( settings, searchData, index, rowData, counter ) {
                var filter_assignees = $('.assigneesBar input:checkbox[name="assignees[]"]:checked').map(function() {
                    return this.value;
                }).get();


                if (filter_assignees.length === 0) {
                    return true;
                }

                if ( filter_assignees.some( r => JSON.parse(searchData[3]).includes(r)) ) {
                    return true;
                }

                return false;
            }
        );
    }


    if ( $('.managersBar').length ) {
        $.fn.dataTable.ext.search.push(
            function( settings, searchData, index, rowData, counter ) {
                var filter_managers = $('.managersBar input:checkbox[name="managers[]"]:checked').map(function() {
                    return this.value;
                }).get();


                if (filter_managers.length === 0) {
                    return true;
                }

                if ( filter_managers.some( r => JSON.parse(searchData[4]).includes(r)) ) {
                    return true;
                }

                return false;
            }
        );
    }


    $('.panel').each(function (index, element) {
        var $panel = $(element);
        var $datatable = $panel.find('.dataTable');
        var datatable = $datatable.DataTable( {
            order: [],
            paging: false,
            info: false,
            //searching: false,
            bStateSave: true,
            dom: 'Blr<"dataTables__tableContainer"t>ip',
            /*language: {
                search:
                  '<svg xmlns="http://www.w3.org/2000/svg" width="15.996" height="16" viewBox="0 0 15.996 16">' +
                  '  <path d="M141.951-813.023a5.594,5.594,0,0,1-4.112-1.684,5.594,5.594,0,0,1-1.684-4.112,5.594,5.594,0,0,1,1.684-4.112,5.594,5.594,0,0,1,4.112-1.684,5.594,5.594,0,0,1,4.112,1.684,5.594,5.594,0,0,1,1.684,4.112,5.558,5.558,0,0,1-.341,1.939,5.419,5.419,0,0,1-.909,1.607l5.453,5.453a.687.687,0,0,1,.2.495.67.67,0,0,1-.2.5.68.68,0,0,1-.5.206.68.68,0,0,1-.5-.206l-5.453-5.453a5.416,5.416,0,0,1-1.635.919A5.616,5.616,0,0,1,141.951-813.023Zm0-1.422a4.222,4.222,0,0,0,3.1-1.271,4.222,4.222,0,0,0,1.271-3.1,4.222,4.222,0,0,0-1.271-3.1,4.222,4.222,0,0,0-3.1-1.271,4.222,4.222,0,0,0-3.1,1.271,4.222,4.222,0,0,0-1.271,3.1,4.222,4.222,0,0,0,1.271,3.1A4.222,4.222,0,0,0,141.951-814.444Z" transform="translate(-136.155 824.614)" fill="#576c71"/>' +
                  '</svg>  _INPUT_',
                searchPlaceholder: $datatable.data('search-placeholder')
            },*/
            /*oLanguage: {
                sSearch: "your-text-here"
            }*/
            /*buttons: [
                'copy', 'csv', 'excel', 'print',
                {
                    extend: 'pdfHtml5',
                    orientation: 'landscape'
                }
            ]*/
        });

        $('.statusBar input:checkbox, .assigneesBar input:checkbox, .managersBar input:checkbox').on('change', function () {
            datatable.draw();
        });

        //Init search bar
        $panel.find('.searchBar input').on('input', function() {
            var value = $(this).val();
            datatable.search( value ).draw();

            var matcher = new RegExp(value, 'gi');
            $('.projectTeaserBoard').show().not(function(){
                return matcher.test($(this).find('.projectTitle, .projectCompany').text())
            }).hide();
        })
    });


    function showOverlay() {
        $('#overlay').addClass('visible');
    }

    function hideOverlay() {
        $('#overlay').removeClass('visible');
    }


    $document.on('click', '.dataTable a', function (e) {
        e.stopPropagation();
    });
    $document.on('click', '[data-action="get_panel"]', function (e) {
        ajaxRequest({
            data: {
                action: 'get_template_part',
                name: 'panel-' + $(this).data('name'),
                id: $(this).data('id')
            },
            success: function(response) {
                $body.append( response.data );
                initPanel();
                popupManager.close();
                showOverlay();
            }
        });
    });


    function initPanel() {
        var $panel = $document.find('.sidePanel');
        var $tabs = $panel.find('.sidePanelTabs');

        if ( $tabs.length ) {
            $tabs.tabs({
                create: function (event, ui) {
                    Scrollbar.init( ui.panel.find('[data-scrollbar]')[0], {
                        continuousScrolling: false,
                        damping: 1
                    } );
                },
                activate: function (event, ui) {
                    Scrollbar.init( ui.newPanel.find('[data-scrollbar]')[0], {
                        continuousScrolling: false,
                        damping: 1
                    } );
                }
            });

            $document.on('click', '[data-action="switch_tab"]', function () {
                $tabs.tabs("option", "active", $( $(this).data('tab_id') ).index() - 1);
            })
        } else {
            Scrollbar.init( $panel.find('[data-scrollbar]')[0], {
                continuousScrolling: false,
                damping: 1
            } );
        }


        const $startDateInput = $panel.find('[name="start_date"]');
        const $endDateInput = $panel.find('[name="end_date"]');
        daterangepicker($panel.find('[data-daterangepicker]')[0], {
            startDate: $startDateInput.val() === '' ? null : $startDateInput.val(),
            endDate: $endDateInput.val() === '' ? null : $endDateInput.val(),
            autoApply: true,
            autoUpdateInput: false,
            buttonClasses: 'btn',
            cancelButtonClasses: 'btn--transparent',
            locale: {
                format: 'yyyy-MM-dd',
            },
            altInput: [$startDateInput[0], $endDateInput[0]],
            altFormat: 'yyyy-MM-dd',
        });

        /*;
        drp.addEventListener('apply', function(e) {
            $startDateInput.val(e.picker.startDate.toISODate());
            $endDateInput.val(e.picker.endDate.toISODate());
        });
        */

        $panel.find('select').select2({
            minimumResultsForSearch: 7,
            width: '100%'
        });

        $panel.find('.sidePanelForm').each(function (index, form) {
            var $form = $(form);
            $form.validate({
                submitHandler: function () {
                    ajaxRequest({
                        data: $form.serialize(),
                        success: function (response) {
                            location.reload();
                        }
                    });
                }
            });
        });

        $panel.find('.formContacts').each(function (index, element) {
            var $contactBlock = $($panel.find('.formGroup--contact:first-child')[0].outerHTML);
            $contactBlock.find('input').removeAttr('value');
            $panel.on('click', '[data-action="add_secondary_contact"]', function () {
                $contactBlock.appendTo( $panel.find('.formContacts') );
            });
        });

        tinymce.EditorManager.execCommand('mceAddEditor', true, 'description');

        setTimeout(function () {
            $panel.addClass('visible');
        }, 100);
    }


    var closePanel = function () {
        $('.sidePanel').removeClass('visible');
        setTimeout(function () {
            tinymce.EditorManager.execCommand('mceRemoveEditor', true, 'description');
            $('.sidePanel').remove();
        }, 300);
        hideOverlay();
    }


    $document.on('click', '[data-panel-close]', closePanel);


    $document.on('click', '.formGroup__close', function () {
        var $contactBlock = $(this).parents('.formGroup');
        $contactBlock.is(':first-child') ? $contactBlock.find('input').removeAttr('value') : $contactBlock.remove();
    });


    $document.on('click', '[data-action="delete"]', function (e) {
        if ( confirm("Are you sure?") ) {
            ajaxRequest({
                data: {
                    action: $(this).data('action'),
                    id: $(this).data('id')
                },
                success: function(response) {
                    location.reload();
                }
            });
        }
    });


    $document.on('click', '[data-action="delete_task"]', function (e) {
        if ( confirm("Are you sure?") ) {
            var $this = $(this);
            ajaxRequest({
                data: {
                    action: $this.data('action'),
                    id: $this.data('id')
                },
                success: function(response) {
                    if ( response.success ) {
                        $this.parents('.taskTeaser').fadeOut(300, ()=>$this.remove());
                        popupManager.close();
                    }
                }
            });
        }
    });


    $document.on('click', '[data-action="archive"]', function (e) {
        if ( confirm("Are you sure?") ) {
            ajaxRequest({
                data: {
                    action: $(this).data('action'),
                    id: $(this).data('id')
                },
                success: function(response) {
                    location.reload();
                }
            });
        }
    });

    $document.on('click', '[name="end_date"]', function (e) {
        e.preventDefault();
        $(this).parents('.sidePanel').find('[name="start_date"]').trigger('click');
    });


    var initSelect = function () {
        $('select').select2({
            minimumResultsForSearch: 7,
            width: '100%'
        });
    }
    initSelect();


    $document.on('change', '[name="company"]', function () {
        $.ajax({
            data: {
                action: 'get_company_contacts',
                id: $(this).val()
            },
            success: function(response) {
                $('[name="contact"]').parents('.formField').show();
                $('[name="contact"]').html( response.data ).select2().trigger('change');
            }
        });
    });


    $document.on('change', '[name="tasks_template"]', function () {
        var ids = $(this).find(':selected').data('ids');
        $('[name="tasks[]"]').each(function (index, element) {
            $(element).prop('checked', ids.includes( parseInt($(element).val()) ));
        });
    });


    $document.on('change', 'form.hoverDropdown__menu :input[type="checkbox"]', function () {
        $(this).parents('.hoverDropdown__menu').addClass('changed');
    });

    $document.on('click', '.hoverDropdown__menu :input[type="radio"]', function () {
        var $this = $(this);
        $this.parents('.hoverDropdown__menu').find('.checkboxBlock').removeClass('checked');
        $this.parents('.checkboxBlock').addClass('checked');
    });



    $document.on('click', 'form.hoverDropdown__menu :input[type="radio"]', function () {
        $.ajax({
            data: $(this).parents('form').serialize(),
            success: function(response) {
                $document.trigger('elements_updated', response.data.ids);
            }
        });
    });


    $document.on('change', '.projectTeaser [name="company"]', function () {
        $.ajax({
            data: $(this).parents('form').serialize(),
            success: function(response) {
                $document.trigger('elements_updated', response.data.ids);
            }
        });
    });


    $document.on('mouseleave', 'form.hoverDropdown__menu.changed', function () {
        var $this = $(this);
        $this.removeClass('changed');
        $.ajax({
            data: $this.serialize(),
            success: function(response) {
                const id = $this.parents('[data-id]').data('id');
                updateElement('[data-id="'+id+'"] .hoverDropdown:has(input[type="checkbox"])');
            }
        });
    });


    $document.on('click', '.taskDates', function (e) {
        e.stopPropagation();
        $('.taskDates').removeClass('edit');
        var $this = $(this);
        $this.addClass('edit');
    });
    $document.on('click', function () {
        $('.taskDates').removeClass('edit');
    });


/*
    $('[data-daterangepicker]').daterangepicker({
        startDate: $(this).find('[name="start_date"]').val(),
        endDate: $(this).find('[name="end_date"]').val(),
        autoApply: true,
    }, function (start, end) {
        ajaxRequest({
            data: {
                action: 'update_project',
                id: $(this).data('id'),
                start_date: start.format('YYYY-MM-DD'),
                end_date: end.format('YYYY-MM-DD')
            }
        });
    });
*/


    $document.on('click', '.projectTeaser [data-daterangepicker]', function (e) {
        e.stopPropagation();
        const $this = $(this);
        const id = $this.parents('[data-id]').data('id');
        const drpElement = daterangepicker($this[0], {
                startDate: $this.find('.dateRange__start').data('date') ?? null,
                endDate: $this.find('.dateRange__end').data('date') ?? null,
                autoApply: true,
                autoUpdateInput: false,
                locale: {
                    format: 'yyyy-MM-dd',
                }
            }, function (start, end) {
                ajaxRequest({
                    data: {
                        action: 'update_project',
                        id: id,
                        start_date: start.toISODate(),
                        end_date: end.toISODate()
                    },
                    success: function (response) {
                        updateElement( '[data-id="'+id+'"] [data-daterangepicker] > *', popupManager.close );
                    }
                });
            }
        );
        const drp = getDateRangePicker(drpElement);
        drpElement.addEventListener('hide', () => drp.remove());
        drp.show();
    });

    /*
    $('.projectTeaser').each(function (index, element) {
        var $this = $(element);
        var $dateRange = $this.find('[data-daterangepicker]');
        $dateRange.daterangepicker({
            //startDate: $dateRange.find('.dateRange__start').data('date') ?? null,
            //endDate: $dateRange.find('.dateRange__end').data('date') ?? null,
            autoApply: true,
        }, function (start, end) {
            ajaxRequest({
                data: {
                    action: 'update_project',
                    id: $this.data('id'),
                    start_date: start.toISODate(),
                    end_date: end.toISODate()
                },
                success: function (response) {
                    updateElement( '[data-id="'+$this.data('id')+'"] [data-daterangepicker] > *', popupManager.close );
                }
            });
        });
    });
     */

/*
    $('.taskTeaser').each(function (index, element) {
        var $this = $(element);
        var $dateRange = $this.find('[data-daterangepicker]');
        daterangepicker($dateRange[0], {
            startDate: $dateRange.find('.dateRange__start').data('date'),
            endDate: $dateRange.find('.dateRange__end').data('date'),
            autoApply: true,
        }, function (start, end) {
            ajaxRequest({
                data: {
                    action: 'update_task',
                    id: $this.data('id'),
                    start_date: start.format('YYYY-MM-DD'),
                    end_date: end.format('YYYY-MM-DD')
                }
            });
        });
    });
*/


    $document.on('click', '.taskTeaser [data-daterangepicker]', function (e) {
        e.stopPropagation();
        const $this = $(this);
        const id = $this.parents('[data-id]').data('id');
        const drpElement = daterangepicker($this[0], {
                startDate: $this.find('.dateRange__start').data('date') ?? null,
                endDate: $this.find('.dateRange__end').data('date') ?? null,
                autoApply: true,
                autoUpdateInput: false,
                locale: {
                    format: 'yyyy-MM-dd',
                }
            }, function (start, end) {
                ajaxRequest({
                    data: {
                        action: 'update_task',
                        id: id,
                        start_date: start.toISODate(),
                        end_date: end.toISODate()
                    },
                    success: function (response) {
                        updateElement( '[data-id="'+id+'"] [data-daterangepicker] > *', popupManager.close );
                    }
                });
            }
        );
        const drp = getDateRangePicker(drpElement);
        drpElement.addEventListener('hide', () => drp.remove());
        drp.show();
    });


    var $btnAddTask = $('.btnAddTask');
    var $formAddTask = $('.formAddTask');
    var $formAddTaskValidator = $formAddTask.validate({
        submitHandler: function (form) {
            ajaxRequest({
                data: $(form).serialize()
            });
        }
    });
    $formAddTask.on('reset', function () {
        $formAddTask.hide();
        $btnAddTask.show();
        $formAddTaskValidator.resetForm();
        $formAddTask[0].reset();
    });
    $document.on('click', '.addTask', function (e) {
        e.stopPropagation();
    });
    $btnAddTask.on('click', function (e) {
        e.stopPropagation();
        $btnAddTask.hide();
        $formAddTask.show();
        $formAddTask.find('input[name="title"]').focus();
    });
    $document.on('click', function () {
        if ( $formAddTask.length ) {
            $formAddTask.trigger('reset');
        }
    });


    $document.on('submit', '.taskTeaser__title form', function (e) {
        e.preventDefault();
        $(this).find('input:focus').blur();
        ajaxRequest({
            beforeSend: false,
            data: $(this).serialize(),
            success: function (response) {}
        });
    });
    $document.on('change', '.taskTeaser input[name="title"]', function () {
        $(this).addClass('changed');
    });
    $document.on('focusout', '.taskTeaser input[name="title"].changed', function () {
        $(this).parents('form').submit();
    });


    $document.on('click', '[data-action="get_popup"]', function (e) {
        ajaxRequest({
            data: $(this).data()
        });
    });


    $document.on('click', '[data-action="delete_time"]', function () {
        var $timeTeaser = $(this).parents('.timeTeaser');
        var datatable = $timeTeaser.parents('table').DataTable();
        $timeTeaser.fadeOut(400, function () {
            datatable.row( $timeTeaser ).remove().draw();
        });
        $.ajax({
            data: {
                action: 'delete_time',
                id: $timeTeaser.data('id'),
            },
            success: function ( response ) {
                $('#main').load( location.href + ' #main > *' );
            }
        });
    });


    function initScrollbars() {
        $('.scrollbar').each(function (index, element) {
            Scrollbar.init( element, {
                continuousScrolling: false,
                damping: 1
            } );
        });
    }
    initScrollbars();


    function updateBoardCategories() {
        var $boardCategories = $('.boardCategory');
        if ( $boardCategories.length ) {
            var hiddenBoardCategories = localStorage.getItem('hiddenBoardCategories');
            hiddenBoardCategories = (hiddenBoardCategories) ? JSON.parse(hiddenBoardCategories) : [];
            $boardCategories.each(function (index, element) {
                var $boardCategory = $(element);
                var category_id = String( $boardCategory.data('id') );
                var is_checked = !hiddenBoardCategories.includes( category_id );
                $boardCategory.toggle( is_checked );
                $('.statusBar input[value="'+category_id+'"]').prop('checked', is_checked);
            });
            Scrollbar.get( $('.board__inner .scrollbar')[0] ).update();
        }
    }
    updateBoardCategories();

    function saveBoardCategories() {
        var hiddenBoardCategories = $('.statusBar input[name="statuses[]"]:not(:checked)').map(function(){
            return $(this).val();
        }).get();
        localStorage.setItem('hiddenBoardCategories', JSON.stringify(hiddenBoardCategories));
        updateBoardCategories();
    }

    $('.statusBar input[name="all"]').on('click', function () {
        $('.statusBar').find('input[name="statuses[]"]').prop('checked', this.checked);
        saveBoardCategories();
    });
    $('.statusBar input[name="statuses[]"]').on('change', function () {
        $('.statusBar input[name="all"]').prop('checked', false);
        saveBoardCategories();
    });



    $( ".boardCategory__teasers" ).sortable({
        connectWith: ".connectedSortable",
        appendTo: document.body,
        helper: "clone",
        receive: function( event, ui ) {
            var $teaser = ui.item;
            var $sender = ui.sender;
            $sender.parents('.boardCategory').find('.projectStatus__count').text(function(i, oldVal) {
                return parseInt(oldVal) - 1;
            });
            $teaser.parents('.boardCategory').find('.projectStatus__count').text(function(i, oldVal) {
                return parseInt(oldVal) + 1;
            });
            Scrollbar.get( $teaser.parents('.scrollbar')[0] ).update();
            Scrollbar.get( $sender.parents('.scrollbar')[0] ).update();
            $teaser.addClass('loading');
            $.ajax({
                data: {
                    action: 'update_project',
                    id: $teaser.data('id'),
                    status: $teaser.parents('.boardCategory').data('id')
                },
                success: function ( response ) {
                    $document.trigger('project_updated', $teaser.data('id'));
                }
            });
        }
    }).disableSelection();


    $document.on('project_updated', updateBoardProjectTeaser);


    function updateBoardProjectTeaser( e, project_id ) {
        $('.projectTeaserBoard[data-id="'+project_id+'"]').each(function (index, element) {
            var $teaser = $(element);
            $teaser.addClass('loading');
            $.ajax({
                data: {
                    action: 'get_template_part',
                    name: $teaser.data('template-part'),
                    id: project_id,
                },
                success: function ( response ) {
                    $teaser.replaceWith( response.data );
                }
            });
        });
    }



    function updateProjectTeasers() {
        var ids = [...arguments].slice(1);
        ids.forEach(function (id) {
            $('.projectTeaser[data-id="'+id+'"]').each(function (index, element) {
                $(element).load( location.href + ' .projectTeaser[data-id="'+id+'"] > *' );
            });
        });
    }
    function updatePopcornTeasers() {
        var ids = [...arguments].slice(1);
        ids.forEach(function (id) {
            $('.projectTeaser[data-id="'+id+'"]').each(function (index, element) {
                $(element).addClass('loading');
                $(element).load( location.href + ' .projectTeaser[data-id="'+id+'"] > *', () => {
                    $(element).find('select').select2({
                        minimumResultsForSearch: 7,
                        width: '100%'
                    });
                    $(element).removeClass('loading');
                } );
            });
        });
    }

    function updateTaskTeasers() {
        var ids = [...arguments].slice(1);
        ids.forEach(function (id) {
            $('.taskTeaser[data-id="'+id+'"]').each(function (index, element) {
                $(element).load( location.href + ' .taskTeaser[data-id="'+id+'"] > *' );
            });
        });
    }


    function updateProjectTime(e, data) {
        var ids = [...arguments].slice(1);
        ids.forEach(function (id) {
            $('.projectTime[data-id="'+id+'"]').each(function (index, element) {
                $(element).load( location.href + ' .projectTime[data-id="'+id+'"] > *' );
            });
        });
    }


    $document.on('elements_updated', updateProjectTeasers);
    $document.on('elements_updated', updateProjectTime);
    $document.on('elements_updated', updatePopcornTeasers);
    $document.on('elements_updated', updateTaskTeasers);


    $document.on('change', '[name="complete"]', function () {
        var $form = $(this).parents('form');
        $form.validate({
            submitHandler: function () {
                ajaxRequest({
                    data: $form.serialize(),
                    success: function ( response ) {
                        $('#main').load( location.href + ' #main > *' );
                        if ( response.data.type ) {
                            switch ( response.data.type ) {
                                case 'reload':
                                    location.reload();
                                    break;
                                case 'redirect':
                                    location.href = response.data.redirect;
                                    break;
                            }
                        } else if ( response.data ) {
                            popupManager.setContent( response.data );
                        } else {
                            popupManager.close();
                        }
                    }
                });
            }
        });
        $form.trigger('submit');
    });


    $document.on('change', '.taskTeaser [name="status"]', function () {
        var $form = $(this).parents('form');
        $form.validate({
            submitHandler: function () {
                ajaxRequest({
                    data: $form.serialize(),
                    success: function ( response ) {
                        if ( response.success ) {
                            $form.parents('.taskTeaser').remove();
                            popupManager.close();
                        } else {
                            popupManager.setContent( response.data.content );
                        }
                    }
                });
            }
        });
        $form.submit();
    });


    $document.on('click', '[data-action="invoice"]', function (e) {
        ajaxRequest({
            data: {
                action: 'invoice',
                id: $(this).data('id')
            }
        });
    });


    $document.on('click', '[data-action="send_to_qb"]', function (e) {
        ajaxRequest({
            data: {
                action: 'send_to_qb',
                id: $(this).data('id')
            }
        });
    });


    $document.on('change', '.sidePanel .hoverDropdown input', function () {
        var $dropdown = $(this).parents('.hoverDropdown');
        $dropdown.find('.avatars .avatar').remove();
        $dropdown.find('input:checked').parents('.checkboxBlock').find('.avatar').clone().prependTo( $dropdown.find('.avatars') );
    });


    $document.on('change', '.popup .hoverDropdown input', function () {
        var $dropdown = $(this).parents('.hoverDropdown');
        $dropdown.find('.avatars .avatar').remove();
        $dropdown.find('input:checked').parents('.checkboxBlock').find('.avatar').clone().prependTo( $dropdown.find('.avatars') );
    });


    $document.on('focusout', '[data-action="project_category_estimation_time"] input', function () {
        var $this = $(this);
        var project_id = $this.parents('[data-action="project_category_estimation_time"]').data('project-id');
        var category_id = $this.parents('[data-action="project_category_estimation_time"]').data('category-id');
        var time = $this.val();
        ajaxRequest({
            data: {
                action: 'update_project_category_estimation_time',
                project_id: project_id,
                category_id: category_id,
                time: time
            }
        });
    });


    $document.on('click', '[data-action="toggle"]', function () {
        $(this).parents('tr').find('.trResource__content').slideToggle();
    });

    new ClipboardJS('.copy', {
        target: function (trigger) {
            return trigger;
        },
    });
});